/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactPersonToCustomerV1Dto } from '../models/ContactPersonToCustomerV1Dto';
import type { CreateContactPersonToCustomerV1Dto } from '../models/CreateContactPersonToCustomerV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchContactPersonToCustomerV1Dto } from '../models/PatchContactPersonToCustomerV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactPersonToCustomersService {
  /**
   * @param requestBody
   * @returns ContactPersonToCustomerV1Dto create entity
   * @throws ApiError
   */
  public static contactPersonToCustomerControllerV1CreateV1(
    requestBody: CreateContactPersonToCustomerV1Dto,
  ): CancelablePromise<ContactPersonToCustomerV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/contact-person-to-customers',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns ContactPersonToCustomerV1Dto a entity list
   * @throws ApiError
   */
  public static contactPersonToCustomerControllerV1FindAllV1(): CancelablePromise<
    Array<ContactPersonToCustomerV1Dto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contact-person-to-customers',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static contactPersonToCustomerControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contact-person-to-customers',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param id contactPersonToCustomerId
   * @returns ContactPersonToCustomerV1Dto the entity
   * @throws ApiError
   */
  public static contactPersonToCustomerControllerV1FindOneV1(
    id: string,
  ): CancelablePromise<ContactPersonToCustomerV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contact-person-to-customers/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param id contactPersonToCustomerId
   * @param requestBody
   * @returns ContactPersonToCustomerV1Dto the update entity
   * @throws ApiError
   */
  public static contactPersonToCustomerControllerV1UpdatePartialV1(
    id: string,
    requestBody: PatchContactPersonToCustomerV1Dto,
  ): CancelablePromise<ContactPersonToCustomerV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/contact-person-to-customers/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param id contactPersonToCustomerId
   * @returns ContactPersonToCustomerV1Dto the entity
   * @throws ApiError
   */
  public static contactPersonToCustomerControllerV1RemoveOneV1(
    id: string,
  ): CancelablePromise<ContactPersonToCustomerV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contact-person-to-customers/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
